// extracted by mini-css-extract-plugin
export default {"root":"gift_card_store_confirmation_page_root__kdhl4"};